import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import useBreakPoinst from "@hooks/useBreakPoinst";
import {
  ModalBox,
  ModalTitle,
  ModalDescription,
  Divider,
  ActionContainer,
  StyledButton,
  CloseButtonContainer,
  ContentWrapper,
  StyledAirbnbIcon,
} from "./styles/AirbnbActivateModal";

import CloseMenu from "../../../../assets/svg/closeMenu.svg?react";
import { LoadingWrapper } from "@components";
import { useProperty } from "@services";
import { ToastMessageContext } from "@context/toast-message-cotnext";
import { useContext, useEffect } from "react";

interface ConnectAirbnbModalProps {
  open: boolean;
  onClose: () => void;
  handleNextModal?: () => void;
  loading?: boolean;
  onRefetchOnboarding?: () => void;
}

const AirbnbActivateModal = ({
  open,
  onClose,
  handleNextModal,
  loading,
  onRefetchOnboarding,
}: ConnectAirbnbModalProps) => {
  const { isPhone } = useBreakPoinst();
  const { t } = useTranslation();
  const { showError } = useContext(ToastMessageContext);

  const { airbnbCreateGroupAndPropertyMutate } = useProperty();
  const { mutate: airbnbCreateGroupAndProperty, isPending, isSuccess } =
    airbnbCreateGroupAndPropertyMutate({
      onSuccess: () => {
        handleNextModal?.();
      },
      onError: () => {
        showError(t("ERRORS.SOMETHING_WENT_WRONG"));
      },
    });

  // Revalidate main onboarding query AFTER API is fulfilled
  useEffect(() => {
    if (isSuccess) {
      onRefetchOnboarding?.();
    }
  }, [isSuccess, onRefetchOnboarding]);

  function handleSubmit() {
    const channexChannelId = localStorage.getItem("channexChannelId");
    if (channexChannelId && channexChannelId !== "null") {
      handleNextModal?.();
    } else {
      airbnbCreateGroupAndProperty();
    }
  }

  return (
    <Modal
      open={open}
      onClose={isPending ? undefined : onClose}
      aria-labelledby="connect-airbnb-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingWrapper loading={isPending}>
        <ModalBox $isPhone={isPhone}>
          <CloseButtonContainer
            onClick={isPending ? undefined : onClose}
            style={{
              cursor: isPending ? "not-allowed" : "pointer",
              opacity: isPending ? 0.5 : 1,
            }}
          >
            <CloseMenu />
          </CloseButtonContainer>

          <ContentWrapper>
            <StyledAirbnbIcon />
            <ModalTitle $isPhone={isPhone}>
              {t("onBoardingJourny.modalTitle")}
              <ModalDescription $isPhone={isPhone}>
                {t("onBoardingJourny.modalDescription")}
              </ModalDescription>
            </ModalTitle>
          </ContentWrapper>

          <Divider />

          <ActionContainer $isPhone={isPhone}>
            <StyledButton
              onClick={handleSubmit}
              $TextColor="white"
              $BgColor="#5B3FFF"
              $isPhone={isPhone}
              $width="127px"
              disabled={isPending}
            >
              {t("onBoardingJourny.connectAccount")}
            </StyledButton>

            <StyledButton
              $TextColor="#5B3FFF"
              $isPhone={isPhone}
              $BgColor="white"
              $width="85px"
              onClick={
                isPending
                  ? undefined
                  : () => {
                      onClose();
                    }
              }
              disabled={isPending}
            >
              {t("onBoardingJourny.skip")}
            </StyledButton>
          </ActionContainer>
        </ModalBox>
      </LoadingWrapper>
    </Modal>
  );
};

export default AirbnbActivateModal;
